/* eslint-disable react-hooks/rules-of-hooks */
import {
  Button,
  Grid,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Space,
  Text,
  TextLabel,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';

import { PolicyApi } from '@Apis';

import { getPolicyName } from '../../utils/fns';
import { PolicyListModalName, PolicyListModalState } from '../../utils/types';
import { reportPendo } from '../../../../utils/setupPendo';
import LoadingBtn from '../../../../components/Common/LoadingBtn';
export const DeleteModal = ({
  modal,
  setModal,
  setRefreshTableTrigger,
}: {
  modal: PolicyListModalState;
  setModal: ({ name, policy }: PolicyListModalState) => void;
  setRefreshTableTrigger: (trigger: Date) => void;
}) => {
  if (modal.name !== 'delete') {
    return <></>;
  }
  const { t } = useTranslation();

  const onClose = () => {
    setModal({
      name: PolicyListModalName.None,
      policy: null,
    });
  };

  const onClick = async () => {
    try {
      await PolicyApi.apiDeletePolicy(modal.policy.policyUuid);
      window.showNotification({
        titleMsg: t('policy.toast.deletePolicy.success'),
        severity: 'success',
      });
    } catch (error) {
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    } finally {
      setRefreshTableTrigger(new Date());
      onClose();
      reportPendo('Policy.Action.Delete', {
        policyName: modal.policy.policyName,
        type: modal.policy.policyType,
        subType: modal.policy.policySubType,
        uuid: modal.policy.policyUuid,
      });
    }
  };

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={modal.name === PolicyListModalName.Delete}
      onClose={onClose}
      size="sm"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent>
        <ModalBody>
          <Text>{t('policy.modals.deletePolicy.title')}</Text>
          <Grid
            gridTemplateColumns="max-content auto"
            gridColumnGap="4px"
            gridRowGap="8px"
            pt="16px"
          >
            <TextLabel>{t('policy.modals.deletePolicy.label.name')}:</TextLabel>
            <Text>{modal.policy?.policyName}</Text>
            <TextLabel>{t('policy.modals.deletePolicy.label.type')}:</TextLabel>
            <Text>
              {t(
                `policy.services.${getPolicyName(
                  modal.policy.policyType,
                  modal.policy.policySubType
                )}.name`
              )}
            </Text>
            <TextLabel>
              {t('policy.modals.deletePolicy.label.description')}:
            </TextLabel>
            <Text>{modal.policy?.policyDescription}</Text>
          </Grid>
        </ModalBody>
        <ModalFooter>
          <LoadingBtn onClick={onClick} variant="primary">
            {t('common.button.ok')}
          </LoadingBtn>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
